export default __webpack_public_path__ + "static/media/pwc.e49da45f.png";